import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import config from "../../contexts/config";
import FloatingChatButton from "../floatingchat/FloatingChat";

import "../solar/solar-model.scss";
import CompanyContact from "../companycontact/CompanyContact";

const BlogModel = () => {
  const chatButton = useRef();
  const [blogData, setBlogData] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetch(`${config.API_URL_ONRENDER}/blog/` + id)
      .then((res) => res.json())
      .then((data) => {
        setBlogData(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [id]);

  return (
    <>
      <div className="solar">
        <div className="solar__hero fade-bottom">
          <img
            src={require(`../../assets/solar/oktatoshatter.jpg`)}
            className="full-imagee"
            alt="hero"></img>
          <div
            className="solar__hero__info"
            style={{ color: "#fff", zIndex: 1, marginTop: "50dvh" }}>
            <motion.h1
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1 }}>
              {blogData.title}
            </motion.h1>
          </div>
        </div>

        <div
          className="solar__section__specs"
          style={{ marginBottom: "150px" }}>
          <div
            className="solar__section__specs__div"
            style={{ flexWrap: "wrap" }}>
            <div className="solar__section__specs__div__main">
              <pre className="blog-text">{blogData.content}</pre>
            </div>
            <div className="solar__section__specs__div__main">
              <div style={{ marginTop: "48px" }}>
                {blogData.fileUrl ? (
                  blogData.fileUrl.includes(".jpeg") ||
                  blogData.fileUrl.includes(".jpg") ||
                  blogData.fileUrl.includes(".png") ||
                  blogData.fileUrl.includes(".gif") ? (
                    <img
                      className="blog-video"
                      src={blogData.fileUrl}
                      alt="blog"></img>
                  ) : (
                    <video
                      className="blog-video"
                      src={blogData.fileUrl}
                      controls></video>
                  )
                ) : blogData.file ? (
                  blogData.file.includes(".jpeg") ||
                  blogData.file.includes(".jpg") ||
                  blogData.file.includes(".png") ||
                  blogData.file.includes(".gif") ? (
                    <img
                      className="blog-video"
                      src={`https://greenislandblog.s3.eu-north-1.amazonaws.com${blogData.file}`}
                      alt="blog"></img>
                  ) : (
                    <video
                      className="blog-video"
                      src={`https://greenislandblog.s3.eu-north-1.amazonaws.com${blogData.file}`}
                      controls></video>
                  )
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>

        <CompanyContact
          onCallback={() => chatButton.current.openChat()}
        />
      </div>
      <FloatingChatButton ref={chatButton} />
    </>
  );
};

export default BlogModel;
